import { useTranslation } from 'react-i18next';
import FaLocal from 'antd/locale/fa_IR';
import EnLocal from 'antd/locale/en_US';
import { DirectionType } from 'antd/es/config-provider';

const useLanguage = () => {
  const { i18n, ...rest } = useTranslation();
  const isFa = i18n.language === 'fa';
  const isEN = !isFa;
  const direction: DirectionType = i18n.dir();
  const currentLocal = isFa ? FaLocal : EnLocal;
  const switchLang = () => i18n.changeLanguage(isFa ? 'en' : 'fa');
  return { isFa, isEN, direction, currentLocal, switchLang, i18n, ...rest };
};
export default useLanguage;
